<template>
  <QDialog
    ref="dialogRef"
    :persistent="persistent"
    :no-backdrop-dismiss="noBackdropDismiss"
    :maximized="Platform.is.mobile"
    @hide="onDialogHide"
  >
    <QCard
      class="q-dialog-plugin full-width"
    >
      <QBtn
        v-if="closeIcon"
        v-close-popup
        icon="close"
        class="absolute-top-right q-mr-md q-mt-md z-top"
        flat
        round
        dense
      />
      <component
        :is="component"
        v-bind="componentProps"
        @ok="onDialogOK"
        @cancel="onDialogCancel"
        @hide="onDialogHide"
      />
    </QCard>
  </QDialog>
</template>

<script setup>
import { useDialogPluginComponent, QBtn, QCard, QDialog, Platform } from 'quasar'

defineProps({
  component: {
    type: Object,
    required: true,
  },
  componentProps: {
    type: Object,
    required: true,
  },
  persistent: {
    type: Boolean,
    default: true,
  },
  noBackdropDismiss: {
    type: Boolean,
    default: undefined,
  },
  // Means there is an X in the top right corner
  // But you can't close it by just clicking outside
  closeIcon: {
    type: Boolean,
    default: false,
  },
})

defineEmits([
  ...useDialogPluginComponent.emits,
])

const {
  dialogRef,
  onDialogOK,
  onDialogCancel,
  onDialogHide,
} = useDialogPluginComponent()
</script>
